import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import './CoreParameters.css';

const CoreParameters = ({ title = 'Core Parameters', items }) => {
  if (!items?.length) {
    return null;
  }

  return (
    <section className="wealth-core-params">
      <div className="wealth-core-params__inner">
        <Reveal>
          <h2 className="wealth-core-params__title">{title}</h2>
        </Reveal>

        <div className="wealth-core-params__grid">
          {items.map(({ title: itemTitle, text, icon }, index) => (
            <Reveal key={itemTitle} delay={index * 80}>
              <article className="wealth-core-params__item">
                {icon ? (
                  <div className="wealth-core-params__icon">
                    <img src={icon} alt="" aria-hidden="true" />
                  </div>
                ) : null}
                <h3 className="wealth-core-params__item-title">{itemTitle}</h3>
                <p className="wealth-core-params__item-text">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreParameters;
